import { render } from "./PayRoot.vue?vue&type=template&id=7946899c&scoped=true"
import script from "./PayRoot.vue?vue&type=script&lang=js"
export * from "./PayRoot.vue?vue&type=script&lang=js"

import "./PayRoot.vue?vue&type=style&index=0&id=7946899c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7946899c"]])

export default __exports__